import {injectable} from 'inversify';

import type {ProgramModel} from './Program.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class ProgramController extends BaseController<ProgramModel> {
  constructor() {
    super();
  }
}
